import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    headerRow: {
      marginTop: theme.spacing(1),
    },
    headerRowCell: {
      color: theme.palette.common.black,
      fontWeight: 700,
      padding: 0,
      borderBottom: 0,
    },
    firstCell: {
      marginRight: 'auto',
      marginLeft: theme.spacing(1),
    },
    secondCell: {
      width: '150px',
    },
    thirdCell: {
      width: '55px',
    },
  };
};
